<template>
  <span>
    <el-popover ref="pop" v-model="visible" placement="bottom" trigger="click">
      <IconHc
        slot="reference"
        class="common-btn ml05 tb-hover-show"
        type="icon-bianji"
      />

      <div v-if="visible" class="edit-content-box" v-loading="loading">
        <el-form :model="formModel" ref="formModel">
          <el-form-item
            prop="content"
          >
            <el-input
              v-model="formModel.content"
              type="textarea"
              :autosize="autosize"
              placeholder="请输入内容"
              :maxlength="maxlength"
              show-word-limit
              :style="textStyle"
            />
          </el-form-item>
        </el-form>
        <div class="button-box">
          <div class="flex-1">
            <slot />
          </div>
          <el-button class="hc-small-button" v-outFocus @click="cancel()">取消</el-button>
          <el-button class="hc-small-button" v-outFocus type="primary" @click="confirm()">保存</el-button>
        </div>
      </div>
    </el-popover>
  </span>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: [Number, String],
      default: 0,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    textStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    autosize: {
      type: [Boolean, Object],
      default: true
    },
    submit: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      visible: false,
      formModel: {
        content: '',
      },
    }
  },
  created() {
    this.formModel.content = this.defaultValue || ''
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.pop.updatePopper()
        })
      }
    }
  },
  methods: {
    confirm() {
      this.$refs.formModel.validate(async(valid) => {
        if (!valid) return
        if (this.submit) {
          this.loading = true
          await this.submit(this.formModel.content)
          this.loading = false
        }
        this.$emit('confirm', this.formModel.content)
        this.visible = false
      })
    },
    cancel() {
      this.visible = false
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.mr10 {
  margin-right: 10px;
}
.edit-content-box {
  .button-box{
    margin-top: 12px;
    display: flex;
    align-items: center;
  }
  .el-form-item--small.el-form-item {
    margin: 0;
  }
  ::v-deep .el-textarea__inner{
    color: $G9;
  }
}

.common-btn {
  color: $main-color;
  cursor: pointer;
}

.ml05 {
  margin-left: 5px;
}
</style>
